export default "__VITE_ASSET__Dxv422jq__"